/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable no-console */

import { useState } from "react";

import { useChat } from "../hooks/useChat";
import addIconGold from "../../../assets/Add-icon-gold.svg";

import FirmsList from "./FirmsList";
import UsersList from "./UsersList";
import ProviderList from "./ProviderList";
import ChatWindow from "./ChatWindow";
import ConnectionStatus from "./ConnectionStatus";
import CreateGroupModal from "./modals/create-group-model";
import MessageInput from "./MessageInput";
import CoPilotList from "./CoPilotList";

const ChatPageLayout = () => {
  const {
    firms,
    selectedFirm,
    users,
    selectedUser,
    connectionStatus,
    loading,
    initializing,
    error,
    handleSelectFirm,
    handleSelectUser,
    messages,
    typingUsers,
    currentUser,
    sendMessage,
    handleTyping,
    markAsRead,
    loadMoreMessages,
    unreadCounts,
    latestMessages,
  } = useChat();
  const [modalOpen, setModalOpen] = useState(false);
  console.log(selectedFirm);
  const [leftPanelCollapsed, setLeftPanelCollapsed] = useState(false);
  console.log(users);
  const containerStyle = {
    display: "flex",
    height: "calc(100% - 50px)",
    backgroundColor: "#ffffff",
    position: "relative",
    overflow: "hidden",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    gap: "5px",
  };

  const leftPanelStyle = {
    width: leftPanelCollapsed ? "0px" : "auto",
    flexShrink: 0,
    transition: "width 0.3s ease",
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    backgroundColor: "white",
    // boxShadow: "4px 0 20px rgba(0,0,0,0.08)",
    zIndex: 2,
    overflow: "hidden",
    borderRight: "0px solid #e2e8f0",
  };

  const toggleButtonStyle = {
    position: "absolute",
    left: leftPanelCollapsed ? "97%" : "250px",
    top: leftPanelCollapsed ? "11px" : "3px",
    zIndex: 10,
    backgroundColor: "var(--primary-80)",
    color: "white",
    border: "none",
    borderRadius: "8px",
    width: "18px",
    height: "18px",
    cursor: "pointer",
    // boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",

    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "bold",
  };

  const chatAreaStyle = {
    flex: "1 1 0",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f8fafc",
    position: "relative",
  };
  const threadId = selectedUser?.threadId || selectedUser?.id;
  console.log(selectedUser);
  const handleSendMessage = (content) => {
    if (threadId && content.trim()) {
      sendMessage(threadId, content.trim());
      // Auto-scroll will be handled by useEffect
    }
  };

  const handleInputTyping = () => {
    if (threadId) {
      handleTyping(threadId);
    }
  };

  return (
    <div
      style={{
        height: "100%",
      }}
    >
      <div style={containerStyle} className="m-t-0">
        <div style={leftPanelStyle}>
          <div
            style={{
              flex: "0 0 auto",
              display: "flex",
              flexDirection: "column",
              borderRight: "0px solid #f1f5f9",
            }}
          >
            <div
              style={{
                paddingLeft: "5px",
                backgroundColor: "var(--primary-5, #3b82f6)",
                color: "white",
                height: "25px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "25px",
                }}
              >
                <div>
                  <h6
                    style={{
                      margin: 0,
                      fontWeight: "600",
                      fontSize: "14px",
                      color: "var(--primary)",
                    }}
                  >
                    Organizations
                  </h6>
                </div>
              </div>
            </div>

            <FirmsList
              firms={firms}
              selectedFirm={selectedFirm}
              onSelectFirm={handleSelectFirm}
              loading={loading.firms}
              error={error.firms}
              unreadCounts={unreadCounts}
              users={users}
            />
          </div>

          <div
            style={{
              flex: "0 0 auto",
              // attorney: as wide as the user rows (which carry 8.5px side padding); others keep the 220px floor
              ...(selectedFirm?.type !== "attorney" && { minWidth: "220px" }),
              display: "flex",
              flexDirection: "column",
              borderLeft: "0px solid #f1f5f9",
              overflow: "hidden",
            }}
          >
            <div
              // style={{
              //   padding: "20px",
              //   backgroundColor: "#f8fafc",
              //   borderBottom: "1px solid #e5e7eb",

              // }}
              style={{
                paddingLeft:
                  selectedFirm?.type === "attorney"
                    ? "0px"
                    : selectedFirm?.type === "copilot"
                      ? "10px"
                      : "10px",
                paddingRight:
                  selectedFirm?.type === "attorney"
                    ? "0px"
                    : selectedFirm?.type === "copilot"
                      ? "10px"
                      : "10px",
                backgroundColor: "var(--primary-10, #3b82f6)",
                color: "var(--primary)",
                height: "25px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "25px",
                  gap: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                {!["attorney"].includes(selectedFirm?.type) && (
                  <div>
                    <h6
                      style={{
                        margin: 0,
                        fontWeight: "600",
                        fontSize: "14px",
                        color: "var(--primary)",
                      }}
                    >
                      {!selectedFirm
                        ? "Select Organization"
                        : selectedFirm?.type === "attorney"
                          ? ""
                          : selectedFirm.name}
                    </h6>
                  </div>
                )}
                {selectedFirm && selectedFirm.type === "attorney" && (
                  <div
                    style={{
                      marginRight: "0px",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center text-center order-last height-25  font-weight-semibold btn-hover-document-row cursor-pointer"
                      onClick={() => setModalOpen(true)}
                      style={{
                        backgroundColor: "var(--primary-5)",
                        color: "var(--primary)",
                        width: "100%",
                        // No border here; the group chat buttons in the list have one.
                        border: "none",
                      }}
                    >
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          gap: "5px",
                          paddingLeft: "5px",
                          paddingRight: "5px",
                        }}
                      >
                        <>
                          <img
                            src={addIconGold}
                            alt="+"
                            style={{
                              width: "15px",
                              height: "15px",
                            }}
                            className="ic d-flex align-items-center justify-content-center"
                          />
                          <span className="text-primary d-flex align-items-center height-25 ">
                            Group Chat
                          </span>
                        </>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {selectedFirm && selectedFirm.type === "attorney" ? (
              <UsersList
                users={users}
                selectedUser={selectedUser}
                onSelectUser={handleSelectUser}
                loading={loading.users}
                error={error.users}
                typingUsers={typingUsers}
                unreadCounts={unreadCounts}
                latestMessages={latestMessages}
              />
            ) : selectedFirm && selectedFirm.type === "copilot" ? (
              <CoPilotList
                users={users}
                selectedUser={selectedUser}
                onSelectUser={handleSelectUser}
                loading={loading.users}
                error={error.users}
                typingUsers={typingUsers}
                unreadCounts={unreadCounts}
                latestMessages={latestMessages}
              />
            ) : selectedFirm && selectedFirm.type === "provider" ? (
              <ProviderList
                users={users}
                selectedUser={selectedUser}
                onSelectUser={handleSelectUser}
                loading={loading.users}
                error={error.users}
                typingUsers={typingUsers}
                unreadCounts={unreadCounts}
                latestMessages={latestMessages}
              />
            ) : (
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "40px",
                  textAlign: "center",
                  color: "#6b7280",
                }}
              >
                <div>
                  <div style={{ fontSize: "32px", marginBottom: "12px" }}>🏢</div>
                  <p style={{ margin: 0, fontSize: "14px", fontWeight: "500" }}>
                    Select an organization to view users
                  </p>
                  <p style={{ margin: "8px 0 0 0", fontSize: "13px", opacity: 0.8 }}>
                    Choose from the left panel to get started
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="m-l-0" style={chatAreaStyle}>
          {selectedUser ? (
            <ChatWindow
              user={selectedUser}
              messages={messages}
              typingUsers={typingUsers}
              currentUser={currentUser}
              sendMessage={sendMessage}
              handleTyping={handleTyping}
              markAsRead={markAsRead}
              loadMoreMessages={loadMoreMessages}
              handleInputTyping={handleInputTyping}
              handleSendMessage={handleSendMessage}
            />
          ) : initializing || loading.firms || loading.users || loading.creating ? (
            <div
              role="status"
              style={{ flex: 1, display: "grid", placeItems: "center", color: "#6b7280" }}
            >
              Loading conversation…
            </div>
          ) : (
            <div
              role="status"
              style={{ flex: 1, display: "grid", placeItems: "center", color: "#6b7280" }}
            >
              {error.general || error.users || error.firms || "No conversations are available."}
            </div>
          )}
        </div>

        {modalOpen && (
          <CreateGroupModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            users={users}
            onCreateGroup={handleSelectUser}
          />
        )}
      </div>
      <MessageInput
        onSendMessage={handleSendMessage}
        onTyping={handleInputTyping}
        placeholder={"Type your message here..."}
        disabled={!threadId}
        recipient={selectedUser}
      />
    </div>
  );
};

export default ChatPageLayout;
